import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import UITextComponent from '../../../Component/UI/Text';
import { StartAudio } from '../../Audio/AudioHelper';
import { AUDIO_GOLD_CARD_COMPLETED } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import BaseUISystem from '../../UI/BaseUISystem';
import { delay } from '../../../Utility/Task/TaskQueue';

interface IFillBarGoldCardsData {
    system: BaseUISystem;
    folded: number;
    total: number;
}

export class FillBarGoldCards extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: IFillBarGoldCardsData
    ): IterableIterator<number> {
        const fill: GameObject = gameObject.find('fill');
        const text: GameObject = gameObject.find('counter');
        const icon: GameObject = gameObject.find('icon');

        const fillElem: ElementComponent = fill.getComponent(ElementComponent);
        const textElem: ElementComponent = text.getComponent(ElementComponent);
        const iconElem: ElementComponent = icon.getComponent(ElementComponent);

        textElem.scale.set(1, 1);

        yield* delay(1000);

        const progress = meta.folded / meta.total;

        if (progress === 1) {
            StartAudio(meta.system.scene, AUDIO_GOLD_CARD_COMPLETED, AudioTrackType.SFX);
        }

        const scaleTween: Tween = this.getTween(fillElem.scale);
        scaleTween.to({ y: progress }, 200).easing(Easing.Linear.None);

        const str = meta.folded + '/' + meta.total;
        text.getComponent(UITextComponent).text = str;

        const txtScaleTween: Tween = this.getTween(textElem.scale);
        txtScaleTween
            .to({ x: 1.25, y: 1.25 }, 100)
            .yoyo(true)
            .repeat(1)
            .start(this.elapsedTime);

        const iconScaleTween: Tween = this.getTween(iconElem.scale);
        iconScaleTween
            .to({ x: 1.25, y: 1.25 }, 100)
            .yoyo(true)
            .repeat(1)
            .start(this.elapsedTime);

        yield* this.startTween(scaleTween);
    }
}
